import TOCNode from './TOCNode';

// v4: Updated to use TOCNode for recursive nesting
export default class TOCSection {
  public label = '';
  public id = '';
  public icon = '';
  public expanded = true;
  public items: TOCNode[] = []; // v4: Changed from TOCItem[] to TOCNode[]
}
